export const prefix = (window.microsDatas?.userId || '$frame-common').substring(0, 6)
